import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/integration/semantik/training_activity`;

export const ACTION_TYPES = {
  FETCH_SEMANTIK_LIST: 'semantik/FETCH_SEMANTIK_LIST',
  FETCH_SEMANTIK_LIST2: 'classroom/FETCH_SEMANTIK_LIST2',
  FETCH_SEMANTIK: 'semantik/FETCH_SEMANTIK',
  CREATE_SEMANTIK: 'semantik/CREATE_SEMANTIK',
  UPDATE_SEMANTIK: 'semantik/UPDATE_SEMANTIK',
  DELETE_SEMANTIK: 'semantik/DELETE_SEMANTIK',
  RESET: 'semantik/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [],
  entities2: [],
  entity: {}, //defaultValue
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const semantikReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_SEMANTIK_LIST):
    case REQUEST(ACTION_TYPES.FETCH_SEMANTIK_LIST2):
    case REQUEST(ACTION_TYPES.FETCH_SEMANTIK):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_SEMANTIK):
    case REQUEST(ACTION_TYPES.UPDATE_SEMANTIK):
    case REQUEST(ACTION_TYPES.DELETE_SEMANTIK):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_SEMANTIK_LIST):
    case FAILURE(ACTION_TYPES.FETCH_SEMANTIK_LIST2):
    case FAILURE(ACTION_TYPES.FETCH_SEMANTIK):
    case FAILURE(ACTION_TYPES.CREATE_SEMANTIK):
    case FAILURE(ACTION_TYPES.UPDATE_SEMANTIK):
    case FAILURE(ACTION_TYPES.DELETE_SEMANTIK):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_SEMANTIK_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_SEMANTIK_LIST2):
    let res2 = action.payload.data;
    return {
        ...state,
        loading: false,
        entities2: res2.content,
    };
    case SUCCESS(ACTION_TYPES.FETCH_SEMANTIK):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_SEMANTIK):
    case SUCCESS(ACTION_TYPES.UPDATE_SEMANTIK):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_SEMANTIK):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default semantikReducer;

// ACTIONS
export const getEntities = (page, size, sort, pencarian) => ({
  type: ACTION_TYPES.FETCH_SEMANTIK_LIST,
  payload: axios.get(`${apiUrl}/search?keyword=${pencarian}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntitiesByClassId = (page, size, sort, classid) => ({
  type: ACTION_TYPES.FETCH_SEMANTIK_LIST2,
  payload: axios.get(`${apiUrl}/classroom/${classid}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_SEMANTIK,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = (entity, classid) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_SEMANTIK,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  dispatch(getEntitiesByClassId(0, 10, 'name,asc', classid));
  return result;
};

export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_SEMANTIK,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  return result;
};

export const deleteEntity = (id, classid) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_SEMANTIK,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: {
      errorMessage: `Gagal hapus, Silahkan cek jaringan dan ulangi proses`,
      successMessage: `Berhasil Hapus!`,
    },
  });
  dispatch(getEntitiesByClassId(0, 10, 'name,asc', classid));
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
